export const ErrorIcon = () => {
    return (
        <svg
            width="160"
            height="160"
            viewBox="0 0 160 160"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M146.682 84.4743H140.672L137.78 77.1899H121.495C121.751 62.1267 123.287 48.1747 126.045 35.6016H46.9993C46.7665 37.8823 46.5571 40.1921 46.3593 42.5136H23.5695L26.4611 49.8037H55.2669L58.1585 57.0939H45.3644C45.3644 57.187 45.3527 57.2801 45.3469 57.3732L45.2364 57.0939H10.4262L13.3178 64.3841H23.5753L26.4669 71.6743H44.864C44.8 74.8161 44.7651 77.9754 44.7651 81.1696C44.7651 91.6248 45.0851 101.748 45.696 111.546H31.9767L34.8684 118.836H26.1702L29.0618 126.127H125.847C124.492 119.831 123.45 113.193 122.717 106.234H110.057L107.165 98.9441H117.277L114.385 91.6539L149.58 91.7587L146.688 84.4685L146.682 84.4743Z"
                fill="#DDDEE1"
            />
            <path
                d="M84.5731 71.5518C75.7993 71.5518 70.6793 75.0194 67.7411 80.0172C70.6793 85.015 75.8051 88.4827 84.5731 88.4827V71.5576V71.5518Z"
                fill="white"
            />
            <path
                d="M84.5731 88.4827C93.3469 88.4827 98.4669 85.015 101.405 80.0172C98.4669 75.0194 93.3411 71.5518 84.5731 71.5518V88.4769V88.4827Z"
                fill="white"
            />
            <path
                d="M90.6066 81.3673C90.6822 80.9484 90.7229 80.5004 90.7229 80.0291C90.7229 79.5578 90.6822 79.0982 90.6066 78.6735C90.1527 76.1426 88.3898 74.5775 85.9229 74.176C85.504 74.1062 85.0618 74.0713 84.6022 74.0713C84.1426 74.0713 83.6655 74.112 83.2233 74.1818C80.7564 74.5949 78.9993 76.1484 78.5396 78.6677C78.464 79.0924 78.4233 79.5462 78.4233 80.0233C78.4233 80.5004 78.464 80.9426 78.5396 81.3615C78.9935 83.8749 80.7506 85.4342 83.2233 85.8473C83.6596 85.9229 84.1193 85.9578 84.6022 85.9578C85.0851 85.9578 85.504 85.9229 85.9229 85.8531C88.3956 85.4517 90.1527 83.8866 90.6066 81.3557V81.3673Z"
                fill="#DDDEE1"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M70.2952 91.8513L96.4072 65.7393L98.851 68.183L72.739 94.295L70.2952 91.8513Z"
                fill="white"
            />
            <path
                d="M44.8582 71.6745H61.6262L58.7345 64.3843H44.8582V71.6745Z"
                fill="#B7B9BE"
            />
            <path
                d="M47.1447 126.132H63.9127L61.0211 118.836H46.6269L47.1447 126.132Z"
                fill="#B7B9BE"
            />
            <path
                d="M121.071 84.3755H110.435L113.327 91.6715H115.991H121.071V84.3755Z"
                fill="#B7B9BE"
            />
        </svg>
    );
};
